export const buttonsRegex = /(\{button:[^}]*\})/g
export const inputHiddenRegex = /(\{input:hidden\})/g
export const queueMessageRegex = /Aguarde que você será atendido/g
export const sellerMessageRegex = /vi aqui que você fez a compra por uma loja parceira e por isso o atendimento só é possível ser feito por lá/g